import { DayOfWeekEnum, type PlayerFinderTimeOfDayEnum } from 'types/generated/client';
import { type FindFilterVariant, type FindFilters, makeDefaultFilters } from 'screens/Find/filters';
import { Weekday } from 'screens/ListAvailability/types';
import type { ForYouPreferences } from './useForYouPreferences';

const WEEKDAY_BY_DAY_OF_WEEK: Record<DayOfWeekEnum, Weekday> = {
  [DayOfWeekEnum.Sunday]: Weekday.Sun,
  [DayOfWeekEnum.Monday]: Weekday.Mon,
  [DayOfWeekEnum.Tuesday]: Weekday.Tue,
  [DayOfWeekEnum.Wednesday]: Weekday.Wed,
  [DayOfWeekEnum.Thursday]: Weekday.Thu,
  [DayOfWeekEnum.Friday]: Weekday.Fri,
  [DayOfWeekEnum.Saturday]: Weekday.Sat,
};

/**
 * The filter set "For you" commits: the variant's defaults with the player's
 * onboarding answers laid over. Radius and price aren't captured in onboarding, so
 * they stay at the defaults. /find has no availability-pattern or venue sections,
 * so there the pattern collapses to its day + time-of-day facets.
 */
export const buildForYouFilters = (
  preferences: ForYouPreferences,
  variant: FindFilterVariant,
): FindFilters => {
  const defaults = makeDefaultFilters(variant);
  const { skillLevels, availabilityDays, timesByDay, venues } = preferences;

  if (variant === 'home') {
    return { ...defaults, skillLevels, availabilityDays, timesByDay, venues };
  }

  const timesOfDay = Array.from(
    new Set(Object.values(timesByDay).flat() as PlayerFinderTimeOfDayEnum[]),
  );
  return {
    ...defaults,
    skillLevels,
    daysOfWeek: availabilityDays.map((day) => WEEKDAY_BY_DAY_OF_WEEK[day]),
    timesOfDay,
  };
};
